import { IProductCategory } from "@iloq/shared/IProduct";
import { queryOptions } from "@tanstack/react-query";
import { AxiosInstance } from "axios";

export const FETCH_CATEGORY_TREE_QUERY_KEY = "fetchCategoryTree";

export async function fetchCategoryTree({
  axiosInstance,
}: {
  axiosInstance: AxiosInstance;
}): Promise<IProductCategory> {
  const response = await axiosInstance.get<IProductCategory>(
    "/api/v1/products/categories",
  );
  return response.data;
}

export function getFetchCategoryTreeQueryOptions({
  axiosInstance,
}: {
  axiosInstance: AxiosInstance;
}) {
  return queryOptions({
    queryKey: [FETCH_CATEGORY_TREE_QUERY_KEY] as const,
    queryFn: () => fetchCategoryTree({ axiosInstance }),
  });
}
